import { ApiResponse, PaginatedCollection, directusApi } from '@/api';
import { asyncForEach, validateFileName } from '@/utils';
import lodash, { forEach } from 'lodash';
import moment from 'moment-timezone';

async function attachPublicationStore(question: any) {
    if (!question?.publication || question.ml_store_name) return question;
    try {
        const post = await directusApi(
            'GET',
            `items/mercadolibre_posts/${question.publication}?fields=ml_store,ml_store_name`,
        );
        const data = post.data?.data ?? {};
        question.ml_store = data.ml_store ?? null;
        question.ml_store_name = data.ml_store_name ?? null;
    } catch (err) {
        question.ml_store = question.ml_store ?? null;
        question.ml_store_name = question.ml_store_name ?? null;
    }
    return question;
}


export interface Question {
    id: number;
    status: string;
    message: {};
    publication: string;
    answer?: any;
    client_id: string;
    updated_by?: string;
    store?: string;
    date_created: string;
    updated_at?: string;
    evaluation?: number;
}

export interface QuestionState {
    activeQuestion: Question | null;
    activeQuestionLoading: boolean;

    // allQuestions: Array<Question>;
    // allQuestionsLoading: boolean;
    pendingQuestions: Array<any>;
    pendingQuestionsLoading: boolean;
    recordQuestions: Array<any>;
    recordQuestionsLoading: boolean;

    responseTime: Array<any>;

    questionsPerPage: number;
    questionsPage: number;
    questionsTotal: number;
    questionsTotalPO: number;
    questionsTotalMeli: number;

}

const state: QuestionState = {
    activeQuestion: {
        id: 0,
        status: '',
        message: {},
        publication: '',
        answer: {},
        client_id: '',
        updated_by: '',
        store: '',
        date_created: '',
        updated_at: '',
        evaluation: 0,
    },
    activeQuestionLoading: false,

    pendingQuestions: [],
    pendingQuestionsLoading: false,
    recordQuestions: [],
    recordQuestionsLoading: false,

    responseTime: [],

    questionsPerPage: 1,
    questionsPage: 1,
    questionsTotal: 1,
    questionsTotalPO: 0,
    questionsTotalMeli: 0,

};

const mutations = {
    TOGGLE_RECORDQUESTIONS_LOADING(state: QuestionState, data: boolean) {
        state.recordQuestionsLoading = data;
    },
    SET_RECORDQUESTIONS(state: QuestionState, data: PaginatedCollection) {
        state.recordQuestions = data.items;
        state.questionsPerPage = data.perPage;
        state.questionsPage = data.currentPage;
        state.questionsTotal = data.totalItems;
        state.questionsTotalPO = data.totalItemsPO;
        state.questionsTotalMeli = data.totalItemsMeli;

    },
    SET_PUSHRECORDS(state: QuestionState, data: PaginatedCollection) {
        state.recordQuestions.forEach(element => {
            data.items.push(element);
        });
        let recordQuestions = lodash.uniqBy(data.items, 'id');
        recordQuestions = lodash.orderBy(recordQuestions, ['date_created'], ['desc']);
        state.recordQuestions = recordQuestions;
        state.questionsTotal = data.totalItems;
        state.questionsTotalPO = data.totalItemsPO;
        state.questionsTotalMeli = data.totalItemsMeli;
    },
    SET_PUSHPENDING(state: QuestionState, data: PaginatedCollection) {
        state.pendingQuestions.forEach(element => {
            data.items.push(element);
        });
        let pendingQuestions = lodash.uniqBy(data.items, 'id');
        pendingQuestions = lodash.orderBy(pendingQuestions, ['date_created'], ['asc']);
        state.pendingQuestions = pendingQuestions;
        state.questionsTotal = data.totalItems;
        state.responseTime = data.times;
    },
    TOGGLE_PENDINGQUESTIONS_LOADING(state: QuestionState, data: boolean) {
        state.pendingQuestionsLoading = data;
    },
    SET_PENDINGQUESTIONS(state: QuestionState, data: PaginatedCollection) {
        state.pendingQuestions = data.items;
        state.questionsPerPage = data.perPage;
        state.questionsTotal = data.totalItems;
        state.responseTime = data.times;
    },
    TOGGLE_ACTIVE_QUESTION_LOADING(state: QuestionState, data: boolean) {
        state.activeQuestionLoading = data;
    },
    SET_ACTIVE_QUESTION(state: QuestionState, data: Question) {
        state.activeQuestion = data;
    },
};

const actions = {
    async getAllRecord(
        { _, commit }: any,
        {
            search,
            page,
        }: any | null
    ) {
        commit('TOGGLE_RECORDQUESTIONS_LOADING', true);

        let limit = 3;
        let params = '';
        if (search) {
            // params += `&search=${search}`;
            params += `&filter[client_id][_contains]=${search}`;
        }
        params += `&filter[status][_neq]=UNANSWERED&meta=total_count&meta=filter_count`;
        if (page) params += `&limit=3&offset=${(page - 1) * limit}`;

        let endpoint = `items/questions?${params}`;

        let records = [];
        let recordsQ0 = [];
        let recordsQ = [];
        let records2 = [];
        let recordsF = [];

        await directusApi('GET', endpoint)
            .then(async res => {
                let question = res.data.data;
                await asyncForEach(question, async (q: any) => {
                    // records.push(q);
                    await directusApi('GET', `items/questions?&filter[status][_neq]=UNANSWERED&filter[client_id]=${q.client_id}&filter[publication]=${q.publication}`).then(async records => {

                        recordsQ = lodash.orderBy(records.data.data, ['date_created'], ['desc']);
                        recordsQ0 = [recordsQ[0]]; //pregunta mas reciente

                    });

                    q.records = recordsQ;

                    if (q.records.length <= 1) {
                        records2.push(await attachPublicationStore({ ...recordsQ0[0], records: [] }))
                    } else {
                        recordsQ.shift();
                        records2.push(await attachPublicationStore({ ...recordsQ0[0], records: recordsQ }));

                    }
                    recordsF = lodash.uniqBy(records2, 'publication');
                });
                commit('SET_RECORDQUESTIONS', {
                    items: recordsF,
                    perPage: limit,
                    currentPage: page,
                    totalItems: res.data.meta.filter_count,
                });
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_RECORDQUESTIONS_LOADING', false);
            });
    },

    async pushRecords({ _, commit }: any, { record, start_date }: any | null) {
        commit('TOGGLE_RECORDQUESTIONS_LOADING', true);

        let fecha = '';
        let params = '';
        let recordsQ0 = [];
        let records2 = [];
        let recordsQ = [];
        let recordsF = [];
        let recordsP = [];
        let recordsM = [];
        let rec = [];

        if (start_date) {
            fecha = moment(start_date).tz("America/Mexico_City").format('YYYY-MM-DD');

            await directusApi('GET', `items/questions?&filter[status][_neq]=UNANSWERED&sort=-date_created&&filter[date_created][_contains]=${fecha}&limit=-1`).then(async records => {
                rec = records.data.data;
                await asyncForEach(rec, async (question: any) => {
                    await attachPublicationStore(question);
                });
                recordsP = rec.filter((q => q.store == null));
                recordsM = rec.filter((q => q.store === 'prodelec'));

                commit('SET_PUSHRECORDS', {
                    items: rec,
                    totalItemsPO: recordsP.length,
                    totalItemsMeli: recordsM.length,
                });

            }).catch(err => {
                console.log(err);
            }).finally(() => {
                commit('TOGGLE_RECORDQUESTIONS_LOADING', false);
            });

        } else {
            params += `&filter[status][_neq]=UNANSWERED&sort=-date_created&meta=total_count&meta=filter_count`;
            params += `&limit=5&offset=${record}`;
            let endpoint = `items/questions?${params}`;

            // Thread of the conversation
            await directusApi('GET', endpoint)
                .then(async res => {
                    let question = res.data.data;
                    await asyncForEach(question, async (q: any) => {
                        await directusApi('GET', `items/questions?&filter[status][_neq]=UNANSWERED&filter[client_id]=${q.client_id}&filter[publication]=${q.publication}`).then(async records => {
                            recordsQ = lodash.orderBy(records.data.data, ['date_created'], ['desc']);
                            recordsQ0 = [recordsQ[0]]; //pregunta mas reciente

                        });
                        q.records = recordsQ;

                        if (q.records.length <= 1) {
                            records2.push(await attachPublicationStore({ ...recordsQ0[0], records: [] }))
                        } else {
                            recordsQ.shift();
                            records2.push(await attachPublicationStore({ ...recordsQ0[0], records: recordsQ }));

                        }
                        recordsF = lodash.uniqBy(records2, 'publication');
                    });
                    commit('SET_PUSHRECORDS', {
                        items: recordsF,
                        totalItems: res.data.meta.filter_count,
                    });
                }).catch(err => {
                    console.log(err);
                }).finally(() => {
                    commit('TOGGLE_RECORDQUESTIONS_LOADING', false);
                });
        }
    },

    async getAllPending({ _, commit }: any, { offset, }: any | null) {
        commit('TOGGLE_PENDINGQUESTIONS_LOADING', true);
        let limit = 3;
        let params = '';
        params += `&filter[status][_eq]=UNANSWERED&sort=date_created&meta=total_count&meta=filter_count`;
        // if (page) params += `&limit=3&offset=${(page - 1) * limit}`;
        params += `&limit=${limit}&offset=${offset}`;

        let endpoint = `items/questions?${params}`;

        let pending = [];
        await directusApi('GET', endpoint)
            .then(async res => {
                let question = res.data.data;
                await asyncForEach(question, async (q: any) => {
                    let recordsQ = [];
                    // await directusApi('GET', `custom/legacy-mercadolibre/users/${q.client_id}`).then(async (client: any) => {
                    //     await directusApi('GET', `custom/legacy-mercadolibre/publicationMl/${q.publication}`).then(async (publication: any) => {
                    let linked_products = [];
                    linked_products = await directusApi('GET', `custom/legacy-mercadolibre/publications/${q.publication}`).then(async post => {
                        q.ml_store = post.data?.ml_store ?? null;
                        q.ml_store_name = post.data?.ml_store_name ?? null;
                        if (post.data.hasOwnProperty('linked_products')) {
                            if (post.data.linked_products.length > 0) {
                                return post.data.linked_products;
                            } else {
                                let linked_products = [];
                                await asyncForEach(post.data.variations, async (variation: any) => {
                                    await asyncForEach(variation.linked_products, async (product: any) => {
                                        linked_products.push(product);
                                    });
                                });
                                return linked_products;
                            }
                        } else {
                            return [];
                        }
                    });
                    await directusApi('GET', `items/questions?&filter[status][_neq]=UNANSWERED&filter[client_id]=${q.client_id}&filter[publication]=${q.publication}`).then(async records => {
                        recordsQ = records.data.data;
                    });


                    q.records = recordsQ;
                    q.send = ''; //Initialize send message to add fast answers
                    linked_products.length > 0 ? q.linked_products = linked_products : q.linked_products = null;
                    pending.push(q);

                    //     });
                    // });
                });
                // console.log(pending);
                let timesInfo = [];
                await directusApi('GET', `items/messages_time`).then(async times => {
                    timesInfo = times.data.data;
                });
                // pending[0].times = timesInfo;
                if (offset == 0) {
                    commit('SET_PENDINGQUESTIONS', {
                        items: pending,
                        times: timesInfo,
                        perPage: limit,
                        totalItems: res.data.meta.filter_count,
                    });
                } else {
                    commit('SET_PUSHPENDING', {
                        items: pending,
                        times: timesInfo,
                        totalItems: res.data.meta.filter_count,
                    });
                }
            })
            .catch(err => {
                console.log(err);
            })
            .finally(() => {
                commit('TOGGLE_PENDINGQUESTIONS_LOADING', false);
            });
    },



    // async pushPending({ _, commit }: any, { record }: any | null) {
    //     commit('TOGGLE_PENDINGQUESTIONS_LOADING', true);
    //     let params = '';
    //     params += `&filter[status][_eq]=UNANSWERED&sort=-date_created&meta=total_count&meta=filter_count`;
    //     params += `&limit=3&offset=${record - 3}`;
    //     let endpoint = `items/questions?${params}`;
    //     let pending = [];
    //     await directusApi('GET', endpoint)
    //         .then(async res => {
    //             let question = res.data.data;
    //             await asyncForEach(question, async (q: any) => {
    //                 let recordsQ = [];
    //                 await directusApi('GET', `custom/legacy-mercadolibre/publicationMl/${q.publication}`).then(async (publication: any) => {
    //                     await directusApi('GET', `items/questions?&filter[status][_neq]=UNANSWERED&filter[client_id]=${q.client_id}&filter[publication]=${q.publication}`).then(async records => {
    //                         recordsQ = records.data.data;
    //                     });
    //                     q.publication = publication.data;
    //                     q.records = recordsQ;
    //                     pending.push(q);
    //                 });
    //             });
    //             commit('SET_PUSHPENDING', {
    //                 items: pending,
    //                 totalItems: res.data.meta.filter_count,
    //             });
    //         })
    //         .catch(err => {
    //             console.log(err);
    //         })
    //         .finally(() => {
    //             commit('TOGGLE_PENDINGQUESTIONS_LOADING', false);
    //         });
    //     // console.log(record);
    // },



    async postQuestion({ _, commit, dispatch }: any, { id, message, store, updated_by }: any | null) {
        if (store == 'prodelec') {
            await directusApi('POST', `custom/legacy-mercadolibre/prodelec/question`, { id, message, updated_by }).then(async res => {
                // console.log(res);
                dispatch("getAllPending", { offset: 0 });
            });
        } else {
            await directusApi('POST', `custom/legacy-mercadolibre/question`, { id, message, updated_by }).then(async res => {
                // console.log(res);
                dispatch("getAllPending", { offset: 0 });
            });
        }
        // return false;
    },

    async blockUser({ _, commit, dispatch }: any, { id, store, client_id }: any | null) {
        if (store == 'prodelec') {
            await directusApi('POST', `custom/legacy-mercadolibre/prodelec/blockUser`, { id, client_id }).then(async res => {
                dispatch("getAllPending", { offset: 0 });
            });
        } else {
            await directusApi('POST', `custom/legacy-mercadolibre/blockUser`, { id, client_id }).then(async res => {
                dispatch("getAllPending", { offset: 0 });
            });
        }
    },

    async deleteQuestion({ _, commit, dispatch }: any, { id, store }: any | null) {
        if (store == 'prodelec') {
            await directusApi('POST', `custom/legacy-mercadolibre/prodelec/deleteQuestion`, { id }).then(async res => {
                dispatch("getAllPending", { offset: 0 });
            });
        } else {
            await directusApi('POST', `custom/legacy-mercadolibre/deleteQuestion`, { id }).then(async res => {
                dispatch("getAllPending", { offset: 0 });
            });
        }
    },

    async evaluar({ _, commit, dispatch }: any, { id, evaluation }: any | null) {

        await directusApi('PATCH', `items/questions/${id}`, { evaluation }).then(async res => {
            // console.log(res);
            dispatch("getAllPending", { offset: 0 });
            // ********************** START adding id of img to promo
            //             await directusApi('PATCH', `items/store_promos/${promo.data.data.id}`, { image })
            //                 .then(async (res: any) => {
            //                     console.log('image added/updated', res.data.data.image);
            //                 })
            //                 .catch(err => {
            //                     console.log(err);
            //                 });
            //             // ********************** END adding id of img to promo
            // evaluation :evaluate;
            console.log(evaluation);
        });
    }

    // async getOne({ _, commit }: any, id: any | null = null) {
    //     commit('TOGGLE_ACTIVE_PROMO_LOADING', true);
    //     if (id) {
    //         await directusApi('GET', `items/store_promos/${id}`)
    //             .then(res => {
    //                 commit('SET_ACTIVE_PROMO', res.data.data);
    //             })
    //             .catch(err => {
    //                 console.log(err);
    //             })
    //             .finally(() => {
    //                 commit('TOGGLE_ACTIVE_PROMO_LOADING', false);
    //             });
    //     } else {
    //         commit('SET_ACTIVE_PROMO', defaultPromo);
    //         commit('TOGGLE_ACTIVE_PROMO_LOADING', false);
    //     }
    // },

    // async postOne({ _, commit, dispatch }: any, data: any) {
    //     commit('TOGGLE_ACTIVE_PROMO_LOADING', true);

    //     let promoEndpoint: string = 'items/store_promos';
    //     let promoMethod: any = 'POST';

    //     if (data.data.id != 0) {
    //         promoMethod = 'PATCH';
    //         promoEndpoint = `items/store_promos/${data.data.id}`;
    //     }

    //     await directusApi(promoMethod, promoEndpoint, {
    //         title: data.data.title,
    //         description: data.data.description,
    //         status: data.data.status,
    //         start_date: data.data.start_date,
    //         end_date: data.data.end_date,
    //         link: data.data.link,
    //         visible: data.data.visible
    //     })
    //         .then(async (promo: any) => {

    //             let image = {};
    //             data.data.image == '' ? image = null : image = promo.data.data.image;

    //             try {
    //                 if (data.data.image.origin == 'upload') {
    //                     let imageNameValidation = await validateFileName(data.data.image.name);
    //                     if (imageNameValidation == 0) {
    //                         console.log('uploading', data.data.image);
    //                         await directusApi('POST', `files`, data.data.image.file)
    //                             .then(async (resFile: any) => {
    //                                 image = { id: resFile.data.data.id };
    //                             })
    //                             .catch(err => {
    //                                 console.log(err);
    //                             });
    //                     } else {
    //                         data.vm.$bvToast.toast(`Error al guardar, la imagen ${data.data.image.name} ya existe.`, {
    //                             title: `Imagen ya existente`,
    //                             variant: 'warning',
    //                             toaster: 'b-toaster-top-center',
    //                             autoHideDelay: 5000,
    //                         });
    //                         commit('TOGGLE_ACTIVE_PROMO_LOADING', false);
    //                         return false;
    //                     }
    //                 } else if (data.data.image.origin == 'directus-update') {
    //                     console.log('img only setted');
    //                     image = { id: data.data.image.id };
    //                 }
    //             } catch (error) {
    //                 console.log('error => no contiene una imagen');
    //             }

    //             // ********************** START adding id of img to promo
    //             await directusApi('PATCH', `items/store_promos/${promo.data.data.id}`, { image })
    //                 .then(async (res: any) => {
    //                     console.log('image added/updated', res.data.data.image);
    //                 })
    //                 .catch(err => {
    //                     console.log(err);
    //                 });
    //             // ********************** END adding id of img to promo

    //             dispatch('getOne', promo.data.data.id);
    //             data.vm.$bvToast.toast('Información agregada/actualizada exitosamente', {
    //                 title: `Obteniendo información`,
    //                 variant: 'success',
    //                 toaster: 'b-toaster-top-center',
    //                 autoHideDelay: 5000,
    //             });

    //             commit('TOGGLE_ACTIVE_PROMO_LOADING', false);
    //             dispatch("getAll", {
    //                 page: 1,
    //                 search: ''
    //             });
    //             commit('SET_ACTIVE_PROMO', promo.data.data);
    //         })
    //         .catch(err => {
    //             console.log(err);
    //         })
    //         .finally(() => {
    //             commit('TOGGLE_ACTIVE_PROMO_LOADING', false);
    //         });
    // },
    // async togglePromoFalse({ _, commit }: any) {
    //     commit('TOGGLE_ACTIVE_PROMO_LOADING', false);
    // },
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
};
